import { useMemo } from "react";

export default function useAddEditAlternatedMaterial({
  datalistOrganization,
  saleOrganization
}: {
  datalistOrganization;
  saleOrganization;
}) {
  const saleOrganizationCodeSelected = useMemo(() => {
    const list = datalistOrganization || [];
    return list.find(e => e.value === saleOrganization)?.code || "";
  }, [saleOrganization, datalistOrganization]);

  return {
    saleOrganizationCodeSelected
  };
}
